import { BoxStyled } from 'pages/Gateways/components/GatewaysForm.styled';
import { GatewayMethodField } from 'pages/Gateways/GatewaysEdit/hooks/useGatewayMethodsFieldArray';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { Box } from 'shared/mui/Box';
import { Checkbox } from 'shared/mui/Checkbox/Checkbox';
import { FormControlLabel } from 'shared/mui/FormControlLabel/FormControlLabel';
import { TooltipWithInfoIcon } from 'shared/mui/Tooltip';
import { Typography } from 'shared/mui/Typography';

import { GatewaysEditPilotSettingsDateTimePicker } from './GatewaysEditPilotSettingsDateTimePicker';
import { GatewaysEditPilotSettingsInfoBox } from './GatewaysEditPilotSettingsInfoBox';
import { GatewaysEditPilotSettingsTable } from './GatewaysEditPilotSettingsTable';
import { GatewaysEditPilotSettingsTimePicker } from './GatewaysEditPilotSettingsTimePicker';

type Props = {
  gatewayMethodFields: GatewayMethodField[];
  isPilotModeSchedule: boolean;
};

export const GatewaysEditPilotSettings = ({
  gatewayMethodFields,
  isPilotModeSchedule,
}: Props): JSX.Element => {
  const { control } = useFormContext();
  const [periodStart, periodEnd] = useWatch({
    control,
    name: ['gatewayPilotModeSchedule.periodStart', 'gatewayPilotModeSchedule.periodEnd'],
  });

  return (
    <>
      <Box mb={3}>
        <Typography fontWeight={500}>Настройки шлюза для пилотного режима</Typography>
      </Box>
      {gatewayMethodFields?.length ? (
        <GatewaysEditPilotSettingsTable gatewayMethodFields={gatewayMethodFields} />
      ) : (
        <GatewaysEditPilotSettingsInfoBox />
      )}
      <Controller
        control={control}
        name="gatewayPilotModeSchedule.schedule"
        render={({ field }) => (
          <FormControlLabel
            control={<Checkbox {...field} checked={field.value} />}
            label={
              <>
                <span style={{ marginRight: '4px' }}>Тестирование по расписанию</span>
                <TooltipWithInfoIcon tooltipText="Определяет период работы шлюза. В иные интервалы шлюз будет недоступен." />
              </>
            }
            sx={{ marginBottom: '24px' }}
          />
        )}
      />
      <Box display="flex">
        <BoxStyled>
          <GatewaysEditPilotSettingsDateTimePicker
            disabled={!isPilotModeSchedule}
            label="Начало периода"
            maxDate={periodEnd ?? undefined}
            name="gatewayPilotModeSchedule.periodStart"
          />
          <GatewaysEditPilotSettingsDateTimePicker
            disabled={!isPilotModeSchedule}
            label="Конец периода"
            minDate={periodStart ?? undefined}
            name="gatewayPilotModeSchedule.periodEnd"
          />
          <GatewaysEditPilotSettingsTimePicker
            disabled={!isPilotModeSchedule}
            label="Рабочее время с"
            name="gatewayPilotModeSchedule.timeStart"
          />
          <GatewaysEditPilotSettingsTimePicker
            disabled={!isPilotModeSchedule}
            label="Рабочее время до"
            name="gatewayPilotModeSchedule.timeEnd"
          />
        </BoxStyled>
      </Box>
    </>
  );
};
